import { routerReducer as routing } from 'react-router-redux';
import { combineReducers } from 'redux';
import * as types from '../actions/types';
import appReducer from '../modules/app';
import userReducer from '../modules/user';
import projectReducer from '../modules/project';
import projectsReducer from '../modules/projects';
import archiveReducer from '../modules/archive';
import infoReducer from '../modules/info';
import dialogsReducer from '../modules/dialogs';

import claddingsReducer from '../modules/data/claddings';
import energyReducer from '../modules/data/energy';
import environmentsReducer from '../modules/data/environments';
import materialsReducer from '../modules/data/materials';
import mediumsReducer from '../modules/data/mediums';
import productsReducer from '../modules/data/products';
import translationsReducer from '../modules/data/translations';
import adaptersReducer from '../modules/data/adapters';
import settingsReducer from '../modules/data/settings';
import materialStandardsReducer from '../modules/data/materialstandards';
import databaseDateReducer from '../modules/data/databasedate';


const filter = (state = '', action) => {
  switch (action.type) {
    case types.FILTER:
      return action.filter;
    default:
      return state;
  }
};

const rootReducer = combineReducers({
    filter,
    routing,
    app: appReducer,
    user: userReducer,
    projects: projectsReducer,
    project: projectReducer,
    info: infoReducer,
    dialogs: dialogsReducer,

    claddings: claddingsReducer,
    energy: energyReducer,
    environments: environmentsReducer,
    materials: materialsReducer,
    mediums: mediumsReducer,
    products: productsReducer,
    translations: translationsReducer,
    adapters: adaptersReducer,
    settings: settingsReducer,
    archive: archiveReducer,
    materialstandards: materialStandardsReducer,
    databasedate: databaseDateReducer,
});

export default rootReducer;
